

import CookieStore from "./storecookie";


export class GoogleAnalytics
{

    public static getClientIds() : Array<string>
    {
        /**
         * GA4 does not support ga.getAll()
         * So we must get client ids from cookies
         */
        return GoogleAnalytics.getClientIdsFromCookies();
    }

    protected static getClientIdsFromTrackers() : Array<string>
    {
        let clientIds = [];
        if (typeof(ga) !== 'undefined') {
            if (typeof(ga.getAll) !== 'undefined') {
                const trackers = ga.getAll();
                for (let i = 0; i < trackers.length; i ++) {
                    const clientId = trackers[i].get('clientId');
                    if (typeof(clientId) === 'string') {
                        clientIds.push(clientId);
                    }
                }
            }    
        }
        return clientIds;
    }

    protected static getClientIdsFromCookies() : Array<string>
    {
        let rawClientIds = new CookieStore().get('_ga');
        let clientIds = [];
        for (let i = 0; i < rawClientIds.length; i ++) {
            if (typeof(rawClientIds[i]) === 'string') {
                let rawClientId = rawClientIds[i];
                // expecting client id from cookie to be of the format
                // GA{int}.{int}.{client_id}
                // reverse the raw client id
                // find the first period
                // take a substring to that point
                // reverse once more to get the actual client id
                rawClientId = rawClientId.split('').reverse().join('');
                rawClientId = rawClientId.substring(0, rawClientId.indexOf('.'));
                rawClientId = rawClientId.split('').reverse().join('');
                clientIds.push(rawClientId);    
            }
        }
        return clientIds;
    }

    public static getSessionIds() : Array<string>
    {
        return GoogleAnalytics.generateTimestampIds('s');
    }

    public static getHitIds() : Array<string>
    {
        return GoogleAnalytics.generateTimestampIds('h');
    }

    protected static generateTimestampIds(prefix: string) : Array<string>
    {
        const id = new Date().getTime();
        return [
            `${prefix}${id}`
        ]
    }


}